import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CardProvider } from "./context/CardContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NavBar from './components/NavBar'; // Import NavBar
import CardDetailsPage from "./pages/CardDetailsPage";
import ProtectedRoute from "./routes/ProtectedRoute";

export default function App() {
  return (
    <AuthProvider>
      <CardProvider>
        <Router>
          <NavBar /> {/* This will make NavBar appear on every page */}

          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/card/:cardId"
              element={
                <ProtectedRoute>
                  <CardDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </CardProvider>
    </AuthProvider>
  );
}
